import React, { useEffect } from "react";
import { MapContainer, Marker, TileLayer, useMap, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { TravelExplore as TravelExploreIcon } from "../icons";
import { T } from "../routes/Translate";
import { brandColors } from "../theme";

// Centro por defecto cuando la tienda todavía no tiene ubicación.
const DEFAULT_CENTER = [-34.603722, -58.381592];

const pinIcon = new L.DivIcon({
  html: `<div style="
    width: 34px; height: 34px; border-radius: 50% 50% 50% 0;
    background: ${brandColors.accent}; transform: rotate(-45deg);
    border: 3px solid white; box-shadow: 0 3px 10px rgba(0,0,0,0.4);
  "></div>`,
  className: "",
  iconSize: [34, 34],
  iconAnchor: [17, 34],
});

const ClickToMove = ({ onPick }) => {
  useMapEvents({
    click: (e) => onPick(e.latlng.lat, e.latlng.lng),
  });
  return null;
};

// Centra el mapa cuando la posición cambia desde afuera (p. ej. al buscar
// la dirección escrita), sin cambiar el zoom que eligió el usuario.
const FollowPosition = ({ position }) => {
  const map = useMap();
  useEffect(() => {
    if (position) map.panTo(position);
  }, [map, position?.[0], position?.[1]]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};

// Mapa para elegir la ubicación de la tienda: tocar el mapa o arrastrar el
// pin llama a onPick(lat, lng); "Buscar dirección" llama a onSearchAddress.
const LocationPicker = ({ latitude, longitude, onPick, onSearchAddress, busy, disabled }) => {
  const hasPosition = typeof latitude === "number" && typeof longitude === "number";
  const position = hasPosition ? [latitude, longitude] : null;

  return (
    <Stack spacing={1}>
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        <T>Tocá el mapa o arrastrá el pin para marcar dónde está tu tienda.</T>
      </Typography>
      <Box sx={{ height: 260, borderRadius: 2, overflow: "hidden", border: `1px solid ${brandColors.divider}` }}>
        <MapContainer center={position || DEFAULT_CENTER} zoom={position ? 16 : 12} style={{ height: "100%", width: "100%" }}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {!disabled && <ClickToMove onPick={onPick} />}
          <FollowPosition position={position} />
          {position && (
            <Marker
              position={position}
              icon={pinIcon}
              draggable={!disabled}
              eventHandlers={{
                dragend: (e) => {
                  const { lat, lng } = e.target.getLatLng();
                  onPick(lat, lng);
                },
              }}
            />
          )}
        </MapContainer>
      </Box>
      <Stack direction="row" spacing={1} alignItems="center">
        <Button
          size="small"
          variant="outlined"
          startIcon={<TravelExploreIcon />}
          onClick={onSearchAddress}
          disabled={disabled || busy}
        >
          <T>Buscar dirección en el mapa</T>
        </Button>
        {busy && <CircularProgress size={18} />}
      </Stack>
    </Stack>
  );
};

export default LocationPicker;
